Controller.$inject = [];

function Controller() {

}

export function HuiAccordionItem() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            variant: '@'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui-accordion-item"
                     ng-class="[$huiCtrl.variant]"
                 ng-transclude></div>
                
            `;
        }
    }
}